import format from 'date-fns/format';
import parse from 'date-fns/parse';

export const dateToReviewFormat = (date) => {
  const dateParsed = date ? parse(date, 'yyyy-MM-dd HH:mm:ss', new Date()) : null;
  return dateParsed ? format(dateParsed, 'dd MMM YYY') : '';
};
